import { call, put, takeLatest } from "@redux-saga/core/effects";
// import { ConfigTableParser } from "./ConfigParser";
import { ConnectorApiData } from "./ConnectorApi";
import { ConnectorConstant } from "./ConnectorConstant";
function* getConnectorData({ payload }) {

  let { filter, search_term,page,limit,from_date,to_date } = payload;
  try {
    yield put({ type: ConnectorConstant.CONNECTOR_REQUEST });
    const res = yield call(ConnectorApiData.getConnectorData, { filter, search_term ,page,limit,from_date,to_date});
    yield put({
      type: ConnectorConstant.CONNECTOR_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ConnectorConstant.CONNECTOR_RESPONSE,
      payload: [],
    });
  }
}


function* postConnectorData({payload}) {
  try {
    yield put({
      type: ConnectorConstant.ADD_CONNECTOR_REQUEST,
    });
    const res = yield call(ConnectorApiData.postConnectorData, payload.payload);

    yield put({
      type: ConnectorConstant.ADD_CONNECTOR_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ConnectorConstant.ADD_CONNECTOR_RESPONSE,
      payload: [],
    });
  }
}
function* postConnectorBulkData() {
  try {
    yield put({
      type: ConnectorConstant.POST_CONNECTOR_BULK_REQUEST,
    });
    const formData = yield call(ConnectorApiData.postBulkData);

    yield put({
      type: ConnectorConstant.POST_CONNECTOR_BULK_RESPONSE,
      payload: formData,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ConnectorConstant.POST_CONNECTOR_BULK_RESPONSE,
      payload: [],
    });
  }
}

function* deleteConnector( {payload }) {
  const id = payload;
console.log('saga', id)
  try {
    yield put({
      type: ConnectorConstant.DELETE_CONNECTOR_REQUEST,
    });
    const res = yield call(ConnectorApiData.DeleteConnectorApi, 
      {id},
    );
    const payload = res;
    yield put({
      type: ConnectorConstant.DELETE_CONNECTOR_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ConnectorConstant.DELETE_CONNECTOR_RESPONSE,
      payload: [],
    });
  }
}
export function* ConnectorDataSaga() {
  yield takeLatest(ConnectorConstant.CONNECTOR_SAGA, getConnectorData);
  yield takeLatest(ConnectorConstant.ADD_CONNECTOR_SAGA, postConnectorData);
  yield takeLatest(ConnectorConstant.POST_CONNECTOR_BULK_SAGA, postConnectorBulkData);
  yield takeLatest(ConnectorConstant.DELETE_CONNECTOR_SAGA, deleteConnector);
}
